"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSummaryResults = exports.questions = void 0;

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

var CHECKLIST_SLEEP = "CHECKLIST_SLEEP";
var questions = [{
  prompt: "What’s the ideal bedroom temperature for a good night’s sleep?",
  type: "radio",
  options: ["9C - 15C (48F - 59F)", "15C - 22C (59F - 72F)", "22C - 25C (72F - 77F)"],
  batteryId: CHECKLIST_SLEEP,
  meta: {
    summaryTitle: "Your answer for the question `the ideal bedroom temperature for a good night’s sleep?`"
  }
}, {
  prompt: "What’s an acceptable amount of light for a good night’s sleep?",
  type: "radio",
  options: ["Pitch black", "Some within room light is ok but not outside", "Blinds open. Lights from outside is ok"],
  batteryId: CHECKLIST_SLEEP,
  meta: {
    summaryTitle: "Your answer for the question `What’s an acceptable amount of light for a good night’s sleep?`"
  }
}, {
  prompt: "What’s the best time to go to bed for a good night's sleep?",
  type: "radio",
  options: ["9-10pm", "10-11pm", "Any time as long as it’s the same time each day"],
  batteryId: CHECKLIST_SLEEP,
  meta: {
    summaryTitle: "Your answer for the question `What’s the best time to go to bed for a good night's sleep?`"
  }
}, {
  prompt: "What is the best bedtime ritual for a good night’s sleep?",
  type: "radio",
  options: ["Warm shower and 15 mins of reading", "Rituals don’t have any impact on sleep", "Screentime (phone, laptop, tv)"],
  batteryId: CHECKLIST_SLEEP,
  meta: {
    summaryTitle: "Your answer for the question `What is the best bedtime ritual for a good night’s sleep?`"
  }
}, {
  prompt: "Which herbal remedies have a small amount of evidence for improving sleep?",
  type: "radio",
  options: ["Valerian root", "Melatonin", "Kava root", "All of the above"],
  batteryId: CHECKLIST_SLEEP,
  meta: {
    summaryTitle: "Your answer for the question `Which herbal remedies have a small amount of evidence for improving sleep?`"
  }
}, {
  prompt: "How strong is the evidence for exercise on improving sleep?",
  type: "radio",
  options: ["Non-existent", "Weak", "Moderate to strong"],
  batteryId: CHECKLIST_SLEEP,
  meta: {
    summaryTitle: "Your answer for the question `How strong is the evidence for exercise on improving sleep?`"
  }
}, {
  prompt: "What is the ideal way to nap?",
  type: "radio",
  options: ["Any amount of time whenever it comes", "Napping is bad for getting a proper sleep", "20-30 mins, not too late in the day"],
  batteryId: CHECKLIST_SLEEP,
  meta: {
    summaryTitle: "Your answer for the question `What is the ideal way to nap?`"
  }
}, {
  prompt: "How long before bed should you consume caffeine to get a good night’s sleep?",
  type: "radio",
  options: ["3 hours", "4 hours", "6 hours"],
  batteryId: CHECKLIST_SLEEP,
  meta: {
    summaryTitle: "Your answer for the question `How long before bed should you consume caffeine to get a good night’s sleep?`"
  }
}, {
  prompt: "How long before bed should you consume alcohol to get a good night’s sleep?",
  type: "radio",
  options: ["3 hours", "4 hours", "6 hours"],
  batteryId: CHECKLIST_SLEEP,
  meta: {
    summaryTitle: "Your answer for the question `How long before bed should you consume alcohol to get a good night’s sleep?`"
  }
}, {
  prompt: "How long before bed should you eat a heavy meal to get a good night’s sleep?",
  type: "radio",
  options: ["3 hours", "4 hours ", "6 hours"],
  batteryId: CHECKLIST_SLEEP,
  meta: {
    summaryTitle: "Your answer for the question `How long before bed should you eat a heavy meal to get a good night’s sleep?`"
  }
}, {
  prompt: "How long before bed should you exercise to get a good night’s sleep?",
  type: "radio",
  options: ["3 hours", "4 hours ", "6 hours"],
  batteryId: CHECKLIST_SLEEP,
  meta: {
    summaryTitle: "Your answer for the question `How long before bed should you exercise to get a good night’s sleep?`"
  }
}, {
  prompt: "How long before bed should you consume nicotine to get a good night’s sleep?",
  type: "radio",
  options: ["3 hours", "4 hours ", "6 hours"],
  batteryId: CHECKLIST_SLEEP,
  meta: {
    summaryTitle: "Your answer for the question `How long before bed should you consume nicotine to get a good night’s sleep?`"
  }
}, {
  prompt: "Which type of noise can be ok for some people to fall asleep to?",
  type: "radio",
  options: ["TV or audiobook on quietly", "Soft noises in the house or room", "Quiet levels of white noise"],
  batteryId: CHECKLIST_SLEEP,
  meta: {
    summaryTitle: "Your answer for the question `Which type of noise can be ok for some people to fall asleep to?`"
  }
}, {
  prompt: "Which activities in bed are NOT recommended for a good night’s sleep?",
  type: "radio",
  options: ["Bringing work to bed", "TV, surfing the internet or screen time", "All of the above"],
  batteryId: CHECKLIST_SLEEP,
  meta: {
    summaryTitle: "Your answer for the question `Which activities in bed are NOT recommended for a good night’s sleep?`"
  }
}, {
  prompt: "If you wake up and can’t get to sleep after half an hour, you should…",
  type: "radio",
  options: ["Stay in bed and try to relax", "Stay in bed and read a boring book", "Get up and read a boring book"],
  batteryId: CHECKLIST_SLEEP,
  meta: {
    summaryTitle: "Your answer for the question `If you wake up and can’t get to sleep after half an hour, you should…`"
  }
}];
exports.questions = questions;

var getSummaryResults = function getSummaryResults(answers) {
  return questions.map(function (question, index) {
    if (!question.hideFromSummary && typeof answers[question.batteryId][index] === 'number') {
      if (question.type === "radio") {
        return {
          question: question,
          answer: question.options[answers[question.batteryId][index]]
        };
      } else {
        return {
          question: question,
          answer: answers[question.batteryId][index]
        };
      }
    }
  }).filter(function (item) {
    return _typeof(item) === "object";
  });
};

exports.getSummaryResults = getSummaryResults;